import axiosServices from '../utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const fetchUser = async () => {
  const response = await axiosServices.post(`${backendUrl}/me`, {
    withCredentials: true,
  });
  return response.data;
};
export const dismissTutorial = async () => {
  const response = await axiosServices.put(
    `${backendUrl}/tutorial_dismiss`,
    { tutorial_dismiss: true },
    {
      withCredentials: true,
    },
  );
  return response.data;
};
export const updateProfile = async (data) => {
  const response = await axiosServices.put(`${backendUrl}/update_profile`, data, {
    withCredentials: true,
  });
  return response.data;
};
export const updatePassword = async (data) => {
  const response = await axiosServices.put(`${backendUrl}/update_password`, data, {
    withCredentials: true,
  });
  return response.data;
};
export const updateEmail = async (data) => {
  const response = await axiosServices.put(`${backendUrl}/update_user_email`, data, {
    withCredentials: true,
  });
  return response.data;
};
export const resendEmail = async (data) => {
  const response = await axiosServices.post(`${backendUrl}/resend_email`, data, {
    withCredentials: true,
  });
  return response.data;
};
export const verifyUpdatedEmail = async (token) => {
  const response = await axiosServices.post(
    `${backendUrl}/verify_updated_email?token=${token}`,
    {},
    {
      withCredentials: true,
    },
  );
  return response.data;
};
export const leaveStudy = async (surveyId, email, study_type) => {
  const studyUrlType = study_type === 'survey' ? 'dynamic-surveys' : 'qualitative-studies';
  const encodedEmail = encodeURIComponent(email);
  return await axiosServices.delete(
    `${backendUrl}/${studyUrlType}/remove-member/${surveyId}/?member_email=${encodedEmail}`,
  );
};

export const skipWorkspacePayment = async (payload) => {
  const response = await axiosServices.post(
    `${backendUrl}/workspaces/skip-workspace-payment/`,
    payload,
    {
      withCredentials: true,
    },
  );

  return response.data;
};

/**
 * Get the current user's notification preferences
 * @returns {Promise<Object>} - The notification preferences
 */
export const getNotificationPreferences = async () => {
  const response = await axiosServices.get(`${backendUrl}/notification-preferences`, {
    withCredentials: true,
  });
  return response.data;
};

/**
 * Update the user's notification preferences
 * @param {Object} preferences - The preferences to update
 * @returns {Promise<Object>} - The updated notification preferences
 */
export const updateNotificationPreferences = async (preferences) => {
  const response = await axiosServices.patch(
    `${backendUrl}/notification-preferences`,
    preferences,
    {
      withCredentials: true,
    },
  );
  return response.data;
};
